export default {
  name: "name",
  in: "query",
  required: false,
  description: "Filtrace na základě jména",
  schema: {
    type: "string",
    example: "John"
  }
};
